const DRAFT_KEY = 'prom_draft';
const COMPLETED_KEY = 'prom_completed';

interface DraftData {
  currentSection: number;
  answers: Record<string, unknown>;
}

export function usePromRateLimit() {
  const isRateLimited = (): boolean => {
    const completed = localStorage.getItem(COMPLETED_KEY);
    if (completed) {
      const parsed = JSON.parse(completed);
      if (Date.now() - parsed.timestamp < 24 * 60 * 60 * 1000) {
        return true;
      }
    }
    return false;
  };

  const saveDraft = (data: DraftData) => {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(data));
  };

  const loadDraft = (): DraftData | null => {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };

  const clearDraft = () => {
    localStorage.removeItem(DRAFT_KEY);
  };

  const markCompleted = () => {
    localStorage.setItem(COMPLETED_KEY, JSON.stringify({ timestamp: Date.now() }));
  };

  const clearCompleted = () => {
    localStorage.removeItem(COMPLETED_KEY);
  };

  return {
    isRateLimited,
    saveDraft,
    loadDraft,
    clearDraft,
    markCompleted,
    clearCompleted,
  };
}
